import React from "react"
import { Redirect, useLocation } from "react-router-dom"

/**
 * The pre-rename `/consumer/subscription-billing` → `/consumer/billing-detail`.
 *
 * This is a component rather than a bare `<Redirect from to="/consumer/billing-detail" />` in
 * App's Switch because of the query string: react-router's string `to` drops it, and the query is
 * the whole point here. Stripe appends `setup_intent_client_secret` /
 * `payment_intent_client_secret` to the return URL on a full-page 3DS redirect, so a card update
 * or past-due payment confirmed against the OLD url — issued moments before this rename shipped —
 * never finalizes if the redirect loses it.
 */
export default function LegacyBillingPathRedirect(): JSX.Element {
  const { search, hash } = useLocation()
  return <Redirect to={{ pathname: "/consumer/billing-detail", search, hash }} />
}
